import React from 'react'

export const MapTypeContext = React.createContext({mapType: null, mapInstance: null, mapEngine: null})

export const withMapContext = Component => props => (
  <MapTypeContext.Consumer>
    {({mapType, mapInstance, mapEngine}) => (
      <Component
        mapType={mapType}
        mapInstance={mapInstance}
        mapEngine={mapEngine}
        {...props} />
    )}
  </MapTypeContext.Consumer>
)
